import IntroTooltip from './introtooltip'

export default IntroTooltip
